export enum OnboardingStatus {
  Created = 'created',
  Completed = 'completed',
  WaitingForApproval = 'waiting_for_approval',
  Failed = 'failed',
  PartiallyCompleted = 'partially_completed',
}

export enum OnboardingStepStatus {
  Created = 'created',
  InProgress = 'in_progress',
  WaitingForInternalApproval = 'waiting_for_internal_approval',
  WaitingForApproval = 'waiting_for_approval',
  Completed = 'completed',
  Failed = 'failed', // Applies only for BG check
}

export enum OnboardingFailureReason {
  Manual = 'manual',
}

export enum OnboardingsTableFields {
  contractorId = 'contractorId',
  contractorName = 'contractorName',
  contractorType = 'contractorType',
  phone = 'phone',
  tags = 'tags',
  onboardingFlow = 'onboardingFlow',
  invitedAt = 'invitedAt',
  toReviewCount = 'toReviewCount',
  stepsCompleted = 'stepsCompleted',
  isActive = 'isActive',
  email = 'email',
  dateOnboarded = 'dateOnboarded',
  actions = 'actions',
  status = 'status',
  failedAt = 'failedAt',
  failureReason = 'failureReason',
}
